var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelValue),expression:"modelValue"}],staticClass:"textarea",class:{
    textarea_error: _vm.error,
    [`textarea_resize-${_vm.resize}`]: _vm.resize
  },domProps:{"value":(_vm.modelValue)},on:{"input":function($event){if($event.target.composing)return;_vm.modelValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }